

class compare_fix {
    constructor(option) {
        class Observer {
            constructor(data) {
                this.data = data;
                this.subEvents = {};
                Object.keys(data).forEach(k => {
                    this.subEvents[k] = [];
                });
            }

            on(key, fn) {
                if (this.subEvents[key]) {
                    this.subEvents[key].push(fn);
                }
            }

            set(key, value) {
                if (this.data[key] != undefined) {
                    this.data[key] = value;
                    this.emit(key, value);
                }
            }

            get(key) {
                return this.data[key];
            }

            emit(key, args) {
                let _this = this;

                let fns = this.subEvents[key];

                if (!fns || fns.length == 0) {
                    return false;
                }

                fns.forEach(fn => {
                    fn.call(this, args);
                });
            }

        }

        this.data = new Observer({
            selectType: 0,
            brand_id: ""
        });
        let that = this;
        this.data.on('selectType', function (val) {
            if (val == 0 && device == 'pc') {
                $('.fix_brand_sorts').show();
            } else {
                $('.fix_brand_sorts').hide();
            }

            if (val == 0 && device == 'mobile') {
                $('.right_fixed_words').show();
            } else {
                $('.right_fixed_words').hide();
            }

            if (val == 0 && that.option.compare_product_count == 0) {
                $('.brand_filter_phylum').show();
            } else {
                $('.brand_filter_phylum').hide();
                $('.brand_filter_phylum .current').removeClass('current');
            }
        });
        
        this.option = option;

        this.data.set();
        this.fix_btn = null;
        this.select_item = null;
        this.select_ul = null;
        this.compare_num = $(".compare_num");
        this.path_item = null;
        this.product_flag = 0;
        this.add_select_path_flag = 0;
        this.selectType = 0; //  0 选品牌  1 选车系  2 选产品

        this.maxNum = option.maxNum == undefined ? 5 : option.maxNum;
        this.product_compare_count = option.compare_product_count ? option.compare_product_count : 0;
        if (!option.selector) {
            this.appendBtn();
        } else {
            this.fix_btn = $(option.selector)
        }
        this.add_itembox();
        this.bindDefault();
        this.common_compare_reset_btn();
        this.back_call(); // this.data.set('selectType', 2)

        
    }

    add_select_path(flag, path_item_id) {
        if ('brand' == flag) {
            var str = '<a href="javascript:;" class="path_item" flag="range_select" brand_id="' + path_item_id + '">系列 ></a>';
        } else if ('range' == flag) {
            var str = '<a href="javascript:;" class="path_item" flag="product_select">产品 ></a>';
        }

        this.select_path.append(str);
    }

    check_product_add(product_id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "post",
                url: "/product_compare_add.ajax.php",
                data: {
                    product_id
                },
                dataType: "json",
                success: function (res) {
                    resolve(res);
                }
            });
        });
    }

    updateLocalCount() {
        this.product_compare_count = $('.fix_compare_item').length;
        this.option.compare_product_count = $('.fix_compare_item').length;
    }

    async add_compare(item_name, item_id) {
        let {
            select_item,
            select_ul,
            select_path,
            option
        } = this;
        let res = await this.check_product_add(item_id);
        console.log(option)
        if (res.result) {
            $("#common_compare_error").html("");
            var str = `<div class="fix_compare_item">
                <img src="${public_domain}/images/brand/user_ico3.png" class="remove_compare" product_id="${item_id}">
                <a href="/product-${item_id}.html" target="_blank" class="compare_item_name"><span>${item_name}</span></a>
            </div>`;
            $("#product_compare_start_btn").show();
            select_item.before(str);
            option.compare_product_count +=1;
            if (5 <= option.compare_product_count) select_item.hide();
            $("#product_compare_count").html(option.compare_product_count);
            $("#compare-car div").html(option.compare_product_count);

            if ('' == $.trim($("#free_compare_phylum_category_condition_area").html())) {
                var condition_str = `<div class="filtrate_item"><span>${res.phylum_name}</span></div>
                                    <div class="filtrate_item" id="compare_category_id" compare_category_id="${res.category_id}">
                                        <span>${res.category_name}</span>
                                        <img src="${public_domain}/images/brand/close_white.png" alt="" class="compare_first_category_close_btn">
                                    </div>`;
                $("#free_compare_phylum_category_condition_area").html(condition_str);
                $(".compare_first_category_close_btn").unbind().bind("click", function () {
                    $(this).parent().remove();
                });
            }

            if (null == $("#compare_category_id").html()) {
                if (1 == res.same_flag) {
                    var category_str = `<div class="filtrate_item" id="compare_category_id" compare_category_id="${res.category_id}">
                                            <span>${res.category_name}</span>
                                            <img src="${public_domain}/images/brand/close_white.png" alt="" class="compare_first_category_close_btn"></div>`;
                    $("#free_compare_phylum_category_condition_area").append(category_str);
                    $(".compare_first_category_close_btn").unbind().bind("click", function () {
                        $(this).parent().remove();
                    });
                }
            }

            select_path.html('');
            select_ul.html('');
            select_path.hide();
            select_ul.hide();
            return true;
        } else {
            $("#common_compare_error").html(res.message);
            return res.message;
        }
    }

    getBrands(ignore_category_id) {
        return new Promise((res, rej) => {
            $.ajax({
                type: "post",
                url: "/get_compare_brand.ajax.php",
                data: {
                    ignore_category_id: ignore_category_id
                },
                dataType: "json",
                success: function (list) {
                    res(list);
                }
            });
        });
    }

    async showBrands(phylum_id) {
        //if('' != html) return false;
        // if (this.product_compare_count == 0) {
        //     this.showPhylum()
        // }
        if (0 == this.product_flag) {
            var free_compare_flag = $("#free_compare_flag").val();
            var compare_category_id = $("#compare_category_id").attr("compare_category_id");
            var ignore_category_id = 0;
            if (1 == free_compare_flag && undefined == compare_category_id) ignore_category_id = 1;
            let list = [];

            if (phylum_id != undefined) {
                list = await this.getBrandsByPhylum(phylum_id);
            } else {
                list = await this.getBrands(ignore_category_id);
            }

            let str = '';
            let sortWord = {};
            list.forEach(brand => {
                sortWord[brand['initial_zh']] = 1;
                str += `<div class="compare_li_item" flag="brand" brand_id="${brand.id}">${brand.initial_zh}-${brand.name_zh}</div>`;
            });
            let wordStr = '';
            let pcWordStr = '';

            for (let key in sortWord) {
                if (sortWord.hasOwnProperty(key)) {
                    wordStr += '<div>' + key + '</div>';
                    pcWordStr += '<div class="fix_brand_sort_item">' + key + '</div>';
                }
            }

            if (wordStr != '') {
                wordStr = '<div class="right_fixed_words">' + wordStr + '</div>';
            }

            this.select_ul.html(str);
            $('.fix_compare_items_box').find('.right_fixed_words').remove();
            $('.fix_compare_items_box').append($(wordStr));
            $('.fix_brand_sorts').html(pcWordStr);
            this.data.set('selectType', 0);
        }

        this.select_path.show();
        this.select_ul.show();
        $(".select_path").html('<a href="javascript:;" class="path_item" flag="brand_select">选择品牌 ></a>');
        this.add_select_path();
    }

    common_compare_reset_btn() {
        let {
            select_item,
            option
        } = this;
        $("#common_compare_reset_btn").unbind().click(function () {
            $.post("/reset_compare_product.ajax.php", {}, function (data) {
                var ret = JSON.parse(data);
                if (false === ret.result) {
                    $("#common_compare_error").html("请至少选择一辆产品");
                    return false;
                } else {
                    $(".fix_compare_item").remove();
                    $("#product_compare_count").html(0);
                    option.compare_product_count = 0
                    select_item.show();
                }
            });
        });
    }

    back_call() {

        if (768 > $(window).width()) {
            $(".compare_back_btn").unbind().click( () =>{
                $(".main").show();
                this.box.hide();
                this.select_ul.hide();
            });
        }
    }

    appendBtn() {

        var str = `<a class="compare_fix_item fixed_link" title="车型对比">
                        <span class="product_val_tips"></span>
                        <img loading="lazy" src="${public_domain}/images/brand/fix_compare.png" class="fix_btn_img" alt="车型对比">
                        <span>车型对比</span>
                    </a>
                    <div id="product_compare_count" style="display:none;"></div>`;
        let item = $(str);

        if (device == 'mobile') {
            $(".fix_btn ").append(item);
        } else {
            $("body").append(item);
            setTimeout(function () {
                var left = ($(window).width() - $(".main").width()) / 2 - 75;
                item.css({
                    'right': left + 'px'
                });
                $('.fix_btn.ysr_site').removeAttr('style').css({
                    'right': left + 'px'
                });
            }, 1);
        }

        this.fix_btn = $(".compare_fix_item");
    }

    add_itembox() {
        var box_str = `
        <div class="fix_compare_items_box">
            <div class="mob_return_title">
                <a href="javascript:;" class="return_btn compare_back_btn">
                    <img src="${public_domain}/images/brand/mob_return.png" alt="">
                    <span>返回</span>
                </a>
                <span>车型对比工具</span>
            </div>
            <div class="pc_header">
                <span>车型对比工具</span>
                <a href="javascript:;">收起 &gt;</a>
            </div>
            <div class="fix_compare_select">
                <img src="${public_domain}/images/brand/select.jpg" alt="" class="select_ico">
                <div class="select_name">选择品牌</div>
            </div>
			<div class="select_path">
				<a href="javascript:;" class="path_item" flag="brand_select">选择品牌 ></a>
            </div>
            <div class="brand_filter_phylum" style="display:none">
                <div class="brand_filter_phylum_item" phylum_id="6">重卡</div>
                <div class="brand_filter_phylum_item" phylum_id="5">中/轻/微卡</div>
                <div class="brand_filter_phylum_item" phylum_id="7">多功能商用车</div>
                <div class="brand_filter_phylum_item" phylum_id="8">皮卡</div>
                <div class="brand_filter_phylum_item" phylum_id="2">客车</div>
                <div class="brand_filter_phylum_item" phylum_id="9">新能源汽车</div>
                <div class="brand_filter_phylum_item" phylum_id="11">专用车</div>
                <div class="brand_filter_phylum_item" phylum_id="3">零部件</div>
                <div class="brand_filter_phylum_item" phylum_id="10">车轮</div>
                <div class="brand_filter_phylum_item" phylum_id="4">润滑油</div>
                <div class="brand_filter_phylum_item" phylum_id="13">座椅</div>
                <div class="brand_filter_phylum_item" phylum_id="12">挂车</div>
            </div>
            <div class="fix_brand_sorts"></div>
			<div class="compare_ul_select"></div>
			<div class="err_tips_box" id="common_compare_error"></div>
            <div class="fix_btn_area">
                <a href="javascript:;" class="start_btn" style="display:none;" id="product_compare_start_btn">开始对比</a>
                <span class="pc_tips_num">最多添加5个</span>
                <a href="javascript:;" class="reset_btn" id="common_compare_reset_btn">清空</a>
            </div>
		</div>`;
        $('body').append(box_str);
        this.box = $(".fix_compare_items_box");
        this.box.hide();
        this.select_item = $(".fix_compare_select");
        this.select_path = $(".select_path");
        this.select_ul = $(".compare_ul_select");
    }

    showBrandsByWord(w) {
        this.box.find('.compare_li_item').each(function (index, item) {
            if ($(item).text().indexOf(w) != -1) {
                $(item).show();
            } else {
                $(item).hide();
            }
        });
    }

    removeCompareItem(product_id, item) {
        let {
            select_item,
            option
        } = this;
        let that = this;
        $.post("/del_compare_product.ajax.php", {
            product_id: product_id
        }, function (data) {
            var ret = eval("(" + data + ")");
            select_item.show();

            if (false === ret.result) {
                $("#common_compare_error").html(ret.message);
                return false;
            } else {
                 option.compare_product_count -= 1;
                $("#product_compare_count").html(option.compare_product_count);
                $("#compare-car div").html(option.compare_product_count);

                that.product_compare_count = option.compare_product_count;
                item.remove();

                if (null == $("#compare_category_id").html()) {
                    if (1 == ret.same_flag) {
                        var category_str = `<div class="filtrate_item" id="compare_category_id" compare_category_id="${ret.category_id}">
                                                <span>${ret.category_name}</span>
                                                <img src="${public_domain}/images/brand/close_white.png" alt="" class="compare_first_category_close_btn">
                                            </div>`;
                        $("#free_compare_phylum_category_condition_area").append(category_str);
                        $(".compare_first_category_close_btn").unbind().bind("click", function () {
                            $(this).parent().remove();
                        });
                    }
                }

                $(".add_compare_click").each(function () {
                    var temp_product_id = $(this).attr("product_id");

                    if (product_id == temp_product_id) {
                        var word = "对比";
                        var plus_and_word = $("#plus_and_word").val();
                        if (1 == plus_and_word) word = "+对比";
                        $(this).removeClass("added");
                        $(this).html(word);
                    }
                });
                that.updateLocalCount();
            }
        });
    }

    getCompareProducts(ignore_category_id) {
        let {
            select_item,
            maxNum,
            option
        } = this;
        let that = this;
        $.post("/get_compare_product.ajax.php", {
            ignore_category_id: ignore_category_id
        }, function (data) {
            var ret = eval("(" + data + ")");
            $("#product_compare_count").html(ret.length);
            option.compare_product_count = ret.length;
            
            if (maxNum <= ret.length) select_item.hide();

            if (0 < ret.length) {
                $("#product_compare_start_btn").show();
                let str = '';
                ret.forEach(item => {
                    str += `<div class="fix_compare_item">
                            <img src="${public_domain}/images/brand/user_ico3.png" class="remove_compare" product_id="${item.id}">
                            <a href="/product-${item.id}.html" target="_blank" class="compare_item_name"><span>${item.name_cn}</span></a>
                        </div>`;
                });
                select_item.before(str);
            }
        });
    }

    setBoxPcPosition() {
        let box = this.box;
        var center_width = 1008;

        let fix_btn = this.fix_btn
        if ($('.main').length > 0) {
            center_width = $('.main').width();
        }

        var gap = ($(window).width() - center_width) / 2 - 65;
        var left_val = fix_btn.offset().left - 300;

        if (gap > $('.fix_compare_items_box').width()) {
            left_val = fix_btn.offset().left + 65;
        }

        box.css({
            top: parseInt(fix_btn.offset().top - $(window).scrollTop()) + 'px',
            left: left_val + 'px'
        });
    }

    async showRanges(brand_id, ignore_category_id) {
        let list = await this.getRanges(brand_id, ignore_category_id);
        var str = "";
        list.forEach(item => {
            str += `<div class="compare_li_item" flag="range" range_id="${item.id}">${item.name_zh}</div>`;
        });
        this.select_ul.html(str);
    }

    getRanges(brand_id, ignore_category_id) {
        return new Promise((res, rej) => {
            $.ajax({
                type: "post",
                url: "/get_compare_range.ajax.php",
                data: {
                    brand_id,
                    ignore_category_id
                },
                dataType: "json",
                success: function (list) {
                    res(list);
                }
            });
        });
    }

    getProducts(range_id, ignore_category_id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "post",
                url: "/get_compare_product_by_range.ajax.php",
                data: {
                    range_id,
                    ignore_category_id
                },
                dataType: "json",
                success: function (list) {
                    resolve(list);
                }
            });
        });
    }

    async showProducts(range_id, ignore_category_id) {
        let list = await this.getProducts(range_id, ignore_category_id);
        var str = "";
        list.forEach(item => {
            str += `<div class="compare_li_item" flag="product" product_id="${item.id}">${item.name_cn}</div>`;
        });
        this.select_ul.html(str); // bind_compare();

        this.add_select_path('range', this.data.brand_id);
    }

    getBrandsByPhylum(phylum_id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "post",
                url: "/get_brand_list_by_phylum.ajax.php",
                data: {
                    phylum_id
                },
                dataType: "json",
                success: function (list) {
                    resolve(list);
                }
            });
        });
    }

    bindDefault() {
        if (1023 < $(window).width()) {
            $(".fix_btn").css({
                right: ($(window).width() - $(".main").width()) / 2 - $(".fix_btn").width() + 'px'
            });
        }

        let {
            select_item,
            fix_btn,
            box,
            select_ul,
            select_path,
            option
        } = this;
        let that = this;
        box.on('click', '.fix_brand_sort_item', function () {
            if (!$(this).hasClass('disabled')) {
                if ($(this).hasClass('current')) {
                    $(this).removeClass('current');
                    that.showBrandsByWord('');
                } else {
                    $(this).addClass('current').siblings().removeClass('current');
                    var w = $(this).text();
                    that.showBrandsByWord(w);
                }
            }
        });
        box.on('click', '.compare_li_item', function () {
            var flag = $(this).attr("flag");

            if ('brand' == flag) {
                var brand_id = $(this).attr("brand_id");
                var free_compare_flag = $("#free_compare_flag").val();
                var compare_category_id = $("#compare_category_id").attr("compare_category_id");
                var ignore_category_id = 0;
                that.data.set('selectType', 1);
                if (1 == free_compare_flag && undefined == compare_category_id) ignore_category_id = 1;
                that.showRanges(brand_id, ignore_category_id);
            } else if ('range' == flag) {
                var range_id = $(this).attr("range_id");
                var free_compare_flag = $("#free_compare_flag").val();
                var compare_category_id = $("#compare_category_id").attr("compare_category_id");
                var ignore_category_id = 0;
                if (1 == free_compare_flag && undefined == compare_category_id) ignore_category_id = 1;
                that.data.set('selectType', 2);
                that.showProducts(range_id, ignore_category_id);
            } else if ('product' == flag) {
                var product_id = $(this).attr("product_id");
                var product_name = $(this).html();
                that.add_compare(product_name, product_id);
            }
        });
        select_path.on('click', '.path_item', function () {
            that.showBrands();
        });
        box.on('click', '.brand_filter_phylum_item', function () {
            if (!$(this).hasClass('current')) {
                $(this).addClass('current').siblings().removeClass('current');
                that.showBrands($(this).attr('phylum_id'));
            } else {
                $(this).removeClass('current');
                that.showBrands();
            }
        });
        box.on('click', '.remove_compare', function () {
            let id = $(this).attr('product_id');
            that.removeCompareItem(id, $(this).parent());
        });
        box.on('click', '.fix_compare_select', function () {
            that.showBrands();
        }); // 点击车型对比按钮

        fix_btn.on('click', function () {
            select_ul.hide();
            $(".fix_compare_item").remove();
            var free_compare_flag = $("#free_compare_flag").val();
            var compare_category_id = $("#compare_category_id").attr("compare_category_id");
            var ignore_category_id = 0;
            if (1 == free_compare_flag && undefined == compare_category_id) ignore_category_id = 1;
            that.getCompareProducts(ignore_category_id);

            if (device == 'pc') {
                that.setBoxPcPosition();
                box.toggle();
            } else {
                var product_compare_count = option.compare_product_count;

                if (product_compare_count == '' || product_compare_count == 0) {
                    $(".compare_fix_item ").removeClass('show_btn');
                }

                box.show().animate({
                    'left': 0
                }, 300, function () {
                    $(".main").hide();
                });
            }
        }); // 移动端返回弹层

        box.on('click', '.return_btn ', function () {
            $(".main").show();
            box.animate({
                'left': '100%'
            }, 300, function () {
                box.hide();
            });
        }); // 移动端字母定位

        box.on('click', '.right_fixed_words div', function () {
            var flag = $(this).text() + '-';
            var list = $('.compare_li_item');
            var top = 0;

            for (var i = 0; i <= list.length; i++) {
                var str = list.eq(i).text();

                if (str.indexOf(flag) != -1) {
                    top = list.eq(i)[0].offsetTop;
                    $('.fix_compare_items_box').animate({
                        'scrollTop': top + 'px'
                    }, 300);
                    return;
                }
            }
        });
        /** 开始对比按钮事件 */

        box.on('click', '.start_btn', function () {
            if (0 >= $(".fix_compare_item").length) {
                $("#common_compare_error").html("请至少选择一辆产品");
                return false;
            } //window.location.href = "/free_compare.php";


            window.open("/free_compare.html");
        });
        $(".pc_header a").click(function () {
            var product_compare_count = option.compare_product_count;

            if (product_compare_count == '' || product_compare_count == 0) {
                $(".compare_fix_item ").removeClass('show_btn');
            }

            box.fadeOut();
        });
    }

}

export default function () {
    $(function () {

    if (1 == global_config.show_compare) {
        var opt = {};
        opt.compare_product_count = compare_product_count;
        opt.selector = '#compare-car'
        const compare_Item =  new compare_fix(opt);
        var fix_btn_top = parseInt($(".compare_fix_item").css('top')) * 1 + parseInt($(".compare_fix_item").css('height')) * 1 + parseInt($(".compare_fix_item").css('padding')) * 2 + 5;
        setTimeout(function () {
            $(".fix_btn").css('top', fix_btn_top);
            if (compare_product_count != 0) {
                $(".compare_fix_item ").addClass('show_btn');
            }
        }, 100);

        $('body').on('click', '.add_compare_click ', function(){
            var id = $(this).attr('product_id');
            compare_Item.add_compare('', id).then(res => {
                console.log(res)
                if (typeof res !== 'string') {
                    $(this).addClass('added')
                }
            })

        })
        }
    })

}